import {
  maxLength,
  required,
  email,
  compare,
  password,
} from '@rxweb/reactive-form-validators';

export class RecoverPassModel {
  @required({ message: 'Este campo es obligatorio.' })
  @password({
    validation: {
      minLength: 8,
      maxLength: 25,
      digit: true,
      //specialCharacter: true,
      lowerCase: true,
      //upperCase: true,
    },
    message: {
      minLength:
        'La contraseña debe tener al menos 8 caracteres, incluyendo una minúscula y un número.',
      maxLength: 'La contraseña debe tener máximo 25 caracteres.',
      digit: 'La contraseña debe incluir al menos un número.',
     /*  specialCharacter:
        'La contraseña debe incluir al menos un carácter especial (*#+!%$"?).', */
      lowerCase: 'La contraseña debe incluir al menos una letra minúscula.',
      //upperCase: 'La contraseña debe incluir al menos una letra mayúscula.',
    },
  })
  password: string;

  @required({ message: 'Este campo es obligatorio.' })
  @maxLength({
    value: 25,
    message: 'La contraseña debe tener máximo 25 caracteres.',
  })
  @compare({ fieldName: 'password', message: 'Las contraseñas no coinciden.' })
  confirmPassword: string;
}
